import React, { useState, useEffect } from "react";
import { Modal, Button, Dropdown, message, Table, Empty } from "antd";
import { FileOutlined, FilePdfOutlined, FileExcelOutlined } from "@ant-design/icons";
import { formatDateAndTime } from "../../Utils/Imports/date-utils";
import { MinusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";

const LostCardLogsModal = ({
  isModalOpen,
  handleCancel,
  lostCardLogs,
  cardNumber,
}) => {
  const { t } = useTranslation();
  console.log("lostCardLogs", lostCardLogs)
  // CSV export state
  const csvHeaders = [
    {
      label: t("lostCardLogsModal.table.date"),
      key: "date",
    },
    {
      label: t("lostCardLogsModal.table.newCardNumber"),
      key: "newCardNumber",
    },
    {
      label: t("lostCardLogsModal.table.oldCardNumber"),
      key: "oldCardNumber",
    },
    {
      label: t("lostCardLogsModal.table.transactionId"),
      key: "transactionId",
    },
    {
      label: t("lostCardLogsModal.table.paidAmount"),
      key: "totalAmount",
    },
  ];
  
  const [csvData, setCsvData] = useState([]);
  // Update CSV data when reprintLogs change
  useEffect(() => {
    const formattedData = (lostCardLogs || []).map((item) => ({
      transactionId: item?.transaction?.id,
      date: item?.created ? formatDateAndTime(item.created) : "-",
      totalAmount: "€ "+ item?.transaction?.totalAmount || "-",
      oldCardNumber: item?.oldCardNumber || "-",
      newCardNumber: item?.newCardNumber || "-",
    }));
    setCsvData(formattedData);
  }, [lostCardLogs]);

  // Export to PDF function
  const exportToPDF = () => {
    try {
      const doc = new jsPDF('landscape');
      
      const title = `${t("reprintLogsModal.title")} - ${t("transactionScreen.table.transactionId")}-${cardNumber}`;
      const pageWidth = doc.internal.pageSize.getWidth();
      const textWidth = doc.getTextWidth(title);
      const xPosition = (pageWidth - textWidth) / 2;
      
      doc.setFontSize(16);
      doc.text(title, xPosition, 20);
      
      const tableColumn = csvHeaders.map((col) => col.label);
      const tableRows = csvData.map((row) => csvHeaders.map((col) => row[col.key]));
      
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 30,
      });

      const filename = `Lost-Card-Logs-${cardNumber}-${dayjs().format('DD-MM-YYYY-hh-mm')}.pdf`;
      doc.save(filename);
    } catch (error) {
      message.error(t("drawerButtons.errorExportPdf"));
    }
  };

  // Generate CSV function
  const handleGenerateCsv = (event, done) => {
    const promise = async () => {
      // CSV data is already set in useEffect
    };
    promise().then(done());
  };

  // Export menu items
  const exportMenuItems = [
    {
      key: "1",
      label: t("drawerButtons.exportPdf"),
      icon: <FilePdfOutlined />,
      onClick: exportToPDF,
    },
    {
      type: "divider",
    },
    {
      key: "2",
      label: (
        <CSVLink
          data={csvData}
          headers={csvHeaders}
          asyncOnClick={true}
          onClick={handleGenerateCsv}
          filename={`Lost-Card-Logs-${cardNumber}-${dayjs().format('DD-MM-YYYY-hh-mm')}.csv`}
        >
          {t("drawerButtons.exportCsv")}
        </CSVLink>
      ),
      icon: <FileExcelOutlined />,
    },
  ];    
  
  const cardLostLogColumns = [
    {
      title: t("lostCardLogsModal.table.date"),
      key: "date",
      render: (record) => {
        return record?.created ? (
          formatDateAndTime(record.created)
        ) : (
          <MinusOutlined />
        );
      },
      sorter: (a, b) => {
        const dateA = new Date(a.created);
        const dateB = new Date(b.created);
        return dateA.getTime() - dateB.getTime();
      },
      show: true,
      width: 180,
    },
    {
      title: t("lostCardLogsModal.table.newCardNumber"),
      key: "newCardNumber",
      render: (record) => {
        return <span>{record?.newCardNumber || "-"}</span>;
      },
      sorter: (a, b) => (a.newCardNumber || "").localeCompare(b.newCardNumber || ""),
      show: true,
      width: 120,
    },
    {
      title: t("transactionScreen.table.oldCardNumber"),
      key: "oldCardNumber",
      render: (record) => {
        return <span>{record?.oldCardNumber || "-"}</span>;
      },
      sorter: (a, b) => (a.oldCardNumber || "").localeCompare(b.oldCardNumber || ""),
      show: true,
      width: 120,
    },
    
    {
      title: t("lostCardLogsModal.table.transactionId"),
      key: "transactionId",
      render: (record) => {
        return <span style={{ wordBreak: 'break-word' }}>{record?.transaction?.id || "-"}</span>;
      },
      sorter: (a, b) => (a?.transaction?.id || "").localeCompare(b?.transaction?.id || ""),
      show: true,
      width: 200,
      ellipsis: true,
    },
    {
      title: t("lostCardLogsModal.table.paidAmount"),
      key: "paidAmount",
      render: (record) => {
        return <span>{record?.transaction?.totalAmount || "-"}</span>;
      },
      sorter: (a, b) => (a.transaction?.totalAmount || "").localeCompare(b.transaction?.totalAmount || ""),
      show: true,
      width: 150,
      ellipsis: true,
    },
  ];return (
    <Modal
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '40px' }}>
          <span>
            {`${t("lostCardLogsModal.title")} - ${t("lostCardLogsModal.currentCardNumber")}: ${cardNumber}`}
          </span>
          <Dropdown menu={{ items: exportMenuItems }} placement="bottomLeft">
            <Button
              icon={<FileOutlined />}
              size="small"
              style={{
                marginRight: 16,
              }}
            >
              {t("drawerButtons.export")}
            </Button>
          </Dropdown>
        </div>
      }     
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      width={1000}
    >      <div style={{ overflowX: 'auto' }}>
        <Table
          size="small"
          columns={cardLostLogColumns.filter((column) => column.show)}
          dataSource={lostCardLogs || []}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} ${t("lostCardLogsModal.replacements")}`,
          }}
          scroll={{ x: 'max-content' }}
          rowKey={(record, index) => record.id || index}          locale={{
            emptyText: <Empty description={t("noData")} />,
          }}
        />
      </div>
    </Modal>
  );
};

export default LostCardLogsModal;
